export const ACTIVE_PROMO_TOGGLE = 'ACTIVE_PROMO_TOGGLE';
